import { motion } from 'framer-motion'
import { cn } from 'src/shared/components/ui/utils'
import { useLocalization } from 'src/shared/hooks/useLocalization'
import { STAMP_EMOJIS } from '../consts'

const WHEEL_SIZE = 224
const RING_RADIUS = 78

/** FigJam-style radial wheel for picking the active stamp. */
export const CanvasStampPicker = ({
  selectedStamp,
  onSelect,
}: {
  selectedStamp: string
  onSelect: (emoji: string) => void
}) => {
  const { t } = useLocalization()

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.8, x: -12 }}
      animate={{ opacity: 1, scale: 1, x: 0 }}
      transition={{ type: 'spring', stiffness: 380, damping: 28 }}
      className="absolute left-16 top-1/2 z-40 -translate-y-1/2"
      onPointerDown={(e) => e.stopPropagation()}
    >
      <div
        className="relative rounded-full border border-gray-200 bg-white shadow-2xl"
        style={{ width: WHEEL_SIZE, height: WHEEL_SIZE }}
      >
        <div className="absolute left-1/2 top-1/2 flex h-16 w-16 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border border-gray-200 bg-gray-50 shadow-inner">
          <span className="rounded-lg border border-gray-200 bg-white p-1 text-2xl leading-none shadow-md">
            {selectedStamp}
          </span>
        </div>

        {STAMP_EMOJIS.map((emoji, index) => {
          const angle = (index / STAMP_EMOJIS.length) * Math.PI * 2 - Math.PI / 2
          const x = Math.cos(angle) * RING_RADIUS
          const y = Math.sin(angle) * RING_RADIUS
          return (
            <button
              key={emoji}
              type="button"
              className={cn(
                'absolute left-1/2 top-1/2 flex h-11 w-11 items-center justify-center rounded-xl transition-transform hover:scale-125',
                selectedStamp === emoji && 'ring-2 ring-blue-500'
              )}
              style={{
                transform: `translate(calc(-50% + ${x}px), calc(-50% + ${y}px)) rotate(${(index % 2 === 0 ? -1 : 1) * 6}deg)`,
              }}
              onClick={() => onSelect(emoji)}
              aria-label={t(`Stamp ${emoji}`, `Stämpel ${emoji}`)}
              aria-pressed={selectedStamp === emoji}
            >
              <span className="rounded-lg border border-gray-200 bg-white p-1 text-2xl leading-none shadow-md">
                {emoji}
              </span>
            </button>
          )
        })}
      </div>
    </motion.div>
  )
}
